module.exports = __webpack_public_path__ + "static/img/9.c1296d25.png";